import { useTranslation } from 'next-i18next';

import { useDialog } from '@zep/dialog';

export const useUnknownErrorDialog = () => {
  const dialog = useDialog();
  const { t } = useTranslation(['common']);

  return (error: unknown) => {
    dialog.alert({
      title: t('common:error.api.unknown'),
    });
    console.error('unknownError', error);
  };
};
